import getConfig from 'next/config';

import JSURL from 'jsurl';

/**
 * @typedef {Object} DataSearchOptions
 * @property {DataSearchTypes} type
 * @property {DataQuery | string | undefined} [query]
 * @property {DataGroupsQuery | undefined} [groups]
 * @property {string | undefined} [language]
 */

/**
 * @param {string} searchId
 * @param {DataSearchOptions} options
 * @returns {Promise<DataSearchApiResponse>}
 */
const get = (searchId, options) => {
  const { publicRuntimeConfig } = getConfig();

  /**
   * @type {DataSearchApiHeaders}
   */
  const headers = {
    Accept: 'application/json',
    'Accept-Language':
      (options && options.language) || publicRuntimeConfig.defaultLanguage,
  };

  let fetchUrl = `${publicRuntimeConfig.dataSearchApiBaseUrl}/${searchId}`;
  fetchUrl += `?type=${options.type}`;

  if (options?.query) {
    const query =
      typeof options.query === 'string'
        ? ['AND', options.query]
        : options.query;
    fetchUrl += `&query=${JSURL.stringify(query)}`;
  }

  if (options?.groups) {
    fetchUrl += `&groups=${JSURL.stringify(options.groups)}&limit=-1`;
  }

  return fetch(fetchUrl, {
    headers,
  }).then((res) => {
    return res.json();
  });
};

export default {
  get,
};
